import * as React from "react";
import { StyleSheet, TouchableOpacity, View, Text  } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { Ionicons } from "@expo/vector-icons";

export default function ToggleInstore({isWeb}) {
  const navigation = useNavigation();
  return (
    <View style={styles.toggleBar}>
      <TouchableOpacity
        style={styles.iconContainer}
        onPress={() => {isWeb == true ? navigation.navigate("WebBuyOnline") : navigation.navigate("BuyOnline")}}
      >
        <Text style={styles.selectedItem}>Online</Text>
      </TouchableOpacity>
      <Text style={styles.unselectedItem}>In-store</Text>
    </View>
  );
}
const styles = StyleSheet.create({
  toggleBar: {
    flexDirection: "row",
    //marginRight: 20,
    borderRadius: 50,
    borderColor: "#ffffff",
    borderWidth: 1,
    justifyContent: "space-evenly",
    alignItems: "center",
    height: 35,
    paddingLeft: 1,
    paddingRight: 1,
    width: 140,
  },
  unselectedItem: {
    color: "#4EBDEF",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 12,
    lineHeight: 30,
    backgroundColor: "#ffffff",
    borderRadius: 15,
    borderColor: "#ffffff",
    borderWidth: 1,
    height: 31,
    width: 70,
    marginRight: 3,
    overflow:"hidden"
  },
  selectedItem: {
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 12,
    lineHeight: 30,
    height: 31,
    width: 70,
    marginLeft: 3,
  },
  iconContainer: {
  },
});
